const WhoThisWorksForSection = () => {
  const businessTypes = [
    {
      icon: 'ri-restaurant-line',
      title: 'Restaurants',
      description: 'From family diners to fine dining, we help you communicate what makes your food special.'
    },
    {
      icon: 'ri-hammer-line',
      title: 'Contractors',
      description: 'Plumbers, electricians, HVAC, roofing—we speak your customers\' language of trust and reliability.'
    },
    {
      icon: 'ri-customer-service-line',
      title: 'Service Providers',
      description: 'Lawyers, accountants, consultants, coaches—we position you as the obvious choice.'
    },
    {
      icon: 'ri-shopping-bag-line',
      title: 'E-commerce',
      description: 'Product descriptions that sell, email sequences that convert, landing pages that perform.'
    },
    {
      icon: 'ri-briefcase-line',
      title: 'Professional Services',
      description: 'Insurance, real estate, financial services—we build trust through clear communication.'
    },
    {
      icon: 'ri-team-line',
      title: 'Agencies',
      description: 'Marketing agencies, design firms, consultancies—we help you articulate your unique value.'
    }
  ];

  return (
    <section className="py-20 px-6 bg-[#a4ae9e]/5">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-[#34444b] mb-6">
            Who This Works For
          </h2>
          <p className="text-xl text-[#73807c] max-w-2xl mx-auto">
            Anyone who's built something real but hasn't figured out how to say it. If you serve people and solve problems, we can help you communicate that.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
          {businessTypes.map((business, index) => (
            <div key={index} className="bg-white p-6 rounded-lg shadow-sm hover:shadow-md transition-shadow">
              <div className="w-12 h-12 bg-[#708474]/10 rounded-lg flex items-center justify-center mb-4">
                <i className={`${business.icon} text-[#708474] text-xl`}></i>
              </div>
              <h3 className="text-xl font-bold text-[#34444b] mb-3">{business.title}</h3>
              <p className="text-[#73807c]">{business.description}</p>
            </div>
          ))}
        </div>

        <div className="bg-white p-8 rounded-lg shadow-sm text-center">
          <h3 className="text-2xl font-bold text-[#34444b] mb-4">
            The Common Thread
          </h3>
          <p className="text-xl text-[#73807c] leading-relaxed max-w-3xl mx-auto">
            You care about your customers. You deliver quality work. You've built something real. But when it comes to explaining what you do and why it matters, the words just don't come. That's where we step in.
          </p>
        </div>
      </div>
    </section>
  );
};

export default WhoThisWorksForSection;